import noOpDispatch from '../util/noOpDispatch';
import requestErrorHandler from './requestErrorHandler';

const login = () => {
    const url = new URL(window.environment.backend + 'auth/login');
    return requestErrorHandler(
        fetch(url.toString(), {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: {
                successUri: window.location.toString()
            }
        }), 'GET', noOpDispatch);
};

export default login;
